// extracted by mini-css-extract-plugin
module.exports = {"slider":"ScoreItem_slider__N-rFq","sliderStyle":"ScoreItem_sliderStyle__wZI0T"};